//step2
import React from 'react';
import { ChevronLeft, ChevronRight, Users, Crown, Ban, CalendarDays, Minus, Plus } from 'lucide-react';

const Step2_DateTimeSelect = ({ 
  service, date, setDate, 
  availableSlots, selectedSlots, toggleSlot, isSlotFull, 
  tier, setTier, 
  guestCount, setGuestCount,
  fixedSlots, parseFixedSlot, handleFixedSlotSelect,
  displayMonth, changeMonth, getDaysInDisplayMonth, formatDay,
  isMember, getTierPrice, goToNext
}) => {

// 追加：tier選択ハンドラ
const handleTierSelect = (t) => {
  setTier(t);

  // ✅ このUIは “申告人数帯（枠）を選ぶ” なので、枠の最大人数を採用
  const max = Number(t?.max ?? 1);
  setGuestCount(Number.isFinite(max) && max > 0 ? max : 1);
};

  const renderGuestSelector = () => (
    <>
      {service.capacity_type === 'person' && (service.capacity > 1) && (
          <div className="mb-6 px-1">
              <div className="bg-gray-50 p-4 rounded-3xl border border-gray-100 flex items-center justify-between">
                  <div className="text-xs font-black text-gray-500">予約人数</div>
                  <div className="flex items-center gap-4">
                      <button onClick={() => setGuestCount(Math.max(1, guestCount - 1))} className="w-8 h-8 rounded-full bg-white border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-100 active:scale-95 transition-all"><Minus size={16}/></button>
                      <span className="text-xl font-black text-gray-800 w-8 text-center">{guestCount}</span>
                      <button onClick={() => setGuestCount(Math.min(service.capacity || 10, guestCount + 1))} className="w-8 h-8 rounded-full bg-gray-900 border border-gray-900 flex items-center justify-center text-white hover:bg-gray-900 active:scale-95 transition-all shadow-md shadow-gray-200"><Plus size={16}/></button>
                  </div>
              </div>
          </div>
      )}
      {service.capacity_type !== 'person' && service.price_tiers && service.price_tiers.length > 0 && (
          <div className="mb-6 px-1">
              <div className="bg-gray-50 p-4 rounded-3xl border border-gray-100">
                  <div className="flex justify-between items-center mb-4">
                      {/* ★修正: 件数ベースの場合は「ご自身を含めた人数」と明記 */}
                      <h4 className="text-[10px] font-black text-gray-500 uppercase tracking-widest flex items-center gap-1"><Users size={12}/> 利用プラン選択 (ご自身を含めた人数)</h4>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                      {service.price_tiers.map((t, idx) => {
                          const isActive = tier && tier.min === t.min && tier.max === t.max;
                          const displayPrice = isMember && t.member_price ? t.member_price : t.price;
                          return (
                              <button key={idx} onClick={() => handleTierSelect(t)} className={`p-3 rounded-xl border text-center transition-all shadow-sm active:scale-95 ${isActive ? 'bg-gray-900 text-white border-gray-900 ring-2 ring-gray-200' : 'bg-white text-gray-600 border-gray-200 hover:border-gray-200'}`}>
                                  <div className="text-xs font-bold mb-1 opacity-90">{t.min}〜{t.max}名様</div>
                                  <div className="font-black text-base flex items-center justify-center gap-1">{isMember && <Crown size={14} className="text-amber-400 fill-amber-400"/>} ¥{Number(displayPrice).toLocaleString()}</div>
                              </button>
                          );
                      })}
                  </div>
              </div>
          </div>
      )}
    </>
  );

  const currentPrice = getTierPrice(tier);
  const priceMultiplier = service.capacity_type === 'person' ? guestCount : 1;
  const totalPrice = currentPrice * selectedSlots.length * priceMultiplier;

  return (
    <div className="animate-in slide-in-from-right duration-300 min-h-full flex flex-col bg-white">
      {service.fixed_slots && service.fixed_slots.length > 0 ? (
          <div className="flex-1 p-6 bg-gray-50">
              {renderGuestSelector()}
              <h4 className="text-[10px] font-black text-gray-500 uppercase tracking-widest mb-3 flex items-center gap-1"><CalendarDays size={12}/> 開催スケジュール</h4>
              <div className="space-y-3 pb-20">
                 {service.fixed_slots
                    .map(parseFixedSlot)
                    .filter((d) => {
                        if (!d) return false;
                        const endTime = new Date(d.getTime() + service.duration * 60000);
                        return endTime > new Date();
                    })
                    .sort((a, b) => a - b)
                    .map((d, i) => {
                      const isFull = isSlotFull(d);
                      const endTime = new Date(d.getTime() + service.duration * 60000);
                      const timeStr = `${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
                      const endTimeStr = `${String(endTime.getHours()).padStart(2,'0')}:${String(endTime.getMinutes()).padStart(2,'0')}`;
                      return (
                          <button key={i} onClick={() => !isFull && handleFixedSlotSelect(d)} disabled={isFull} className={`w-full bg-white p-5 rounded-3xl border flex items-center justify-between transition-all group ${isFull ? 'border-gray-100 opacity-60 cursor-not-allowed grayscale' : 'border-gray-200 hover:border-gray-900 hover:shadow-md active:scale-[0.98]'}`}>
                              <div className="text-left"><div className="text-sm font-bold text-gray-500 mb-1 flex items-center gap-2"><span className="px-2 py-0.5 bg-gray-100 rounded text-gray-600 text-xs font-black">{formatDay(d)}</span>{d.getMonth() + 1}月{d.getDate()}日</div><div className="text-2xl font-black text-gray-800 tracking-tight flex items-baseline gap-1">{timeStr} <span className="text-sm font-bold text-gray-500">~ {endTimeStr}</span></div></div>
                              <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-colors ${isFull ? 'bg-gray-100 text-gray-500' : 'bg-gray-50 text-gray-900 group-hover:bg-gray-900 group-hover:text-white'}`}>{isFull ? <Ban size={20}/> : <ChevronRight size={20}/>}</div>
                          </button>
                      );
                  })}
                  {service.fixed_slots.length === 0 && <p className="text-center text-gray-500 text-sm py-8">現在、開催予定はありません</p>}
              </div>
          </div>
      ) : (
          <>
            <div className="p-4 border-b border-gray-100">
                <div className="flex items-center justify-between mb-4 px-2">
                    <button onClick={() => changeMonth(-1)} className="p-2 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors"><ChevronLeft size={20} className="text-gray-600"/></button>
                    <h4 className="text-lg font-black text-gray-800">{displayMonth.getFullYear()}年 {displayMonth.getMonth() + 1}月</h4>
                    <button onClick={() => changeMonth(1)} className="p-2 bg-gray-100 rounded-full hover:bg-gray-200 transition-colors"><ChevronRight size={20} className="text-gray-600"/></button>
                </div>
                <div className="flex gap-3 overflow-x-auto pb-2 no-scrollbar snap-x">
                {getDaysInDisplayMonth().map((d, i) => {
                    const isSelected = d.getDate() === date.getDate() && d.getMonth() === date.getMonth();
                    return (<button key={i} onClick={() => { setDate(d); /* slotsリセット等の処理は親の toggleSlot(null) 等で */ }} className={`flex-shrink-0 w-14 h-20 rounded-3xl flex flex-col items-center justify-center gap-1 snap-start transition-all border-2 ${isSelected ? 'bg-gray-900 border-gray-900 text-white shadow-lg shadow-gray-200' : 'bg-white border-gray-200 text-gray-700'}`}><span className="text-[10px] font-black uppercase">{formatDay(d)}</span><span className="text-xl font-black">{d.getDate()}</span></button>);
                })}
                </div>
            </div>
            <div className="flex-1 p-6 bg-gray-50">
                {renderGuestSelector()}
                <div className="flex justify-between items-end mb-4"><h4 className="text-[10px] font-black text-gray-500 uppercase tracking-widest">空き時間 ({date.getMonth()+1}/{date.getDate()})</h4>{service.allow_multiple_slots && <span className="text-[10px] font-bold text-gray-900 bg-gray-50 px-2 py-1 rounded">複数選択可</span>}</div>
                <div className="grid grid-cols-3 gap-3 pb-20">
                {availableSlots.map((time, i) => {
                    const isSelected = selectedSlots.some(t => t.getTime() === time.getTime());
                    const isFull = isSlotFull(time);
                    return (<button key={i} onClick={() => !isFull && toggleSlot(time)} disabled={isFull} className={`py-4 rounded-xl font-bold text-sm border shadow-sm transition-all ${isFull ? 'bg-gray-100 text-gray-300 border-gray-100 cursor-not-allowed opacity-80' : isSelected ? 'bg-gray-900 text-white border-gray-900 ring-2 ring-gray-200 active:scale-95' : 'bg-white text-gray-600 border-gray-200 hover:border-gray-900 active:scale-95'}`}>{isFull ? <div className="flex flex-col items-center gap-0.5"><span>{String(time.getHours()).padStart(2, '0')}:{String(time.getMinutes()).padStart(2, '0')}</span><span className="text-[9px] text-gray-500">FULL</span></div> : `${String(time.getHours()).padStart(2, '0')}:${String(time.getMinutes()).padStart(2, '0')}`}</button>);
                })}
                </div>
                {selectedSlots.length > 0 && (<div className="sticky bottom-4 mt-6 animate-in slide-in-from-bottom-4"><button onClick={goToNext} className="w-full bg-gray-900 text-white p-4 rounded-3xl font-black shadow-xl active:scale-95 transition-all flex items-center justify-center gap-2"><div><span className="text-xs font-normal opacity-70 block text-left">¥{getTierPrice(tier).toLocaleString()} × {selectedSlots.length}枠</span><span>次へ: ¥{totalPrice.toLocaleString()}</span></div><ChevronRight size={16}/></button></div>)}
            </div>
          </>
      )}
    </div>
  );
};

export default Step2_DateTimeSelect;